import React, { useMemo } from "react";

import { useQuery } from "@apollo/client";
import get from "lodash/get";
import PropTypes from "prop-types";
import withLoader from "shared/components/Loader/withLoader";
import { FOLDERS } from "shared/graphql/queries";
import { PAGINATION_SIZE } from "utils/constants";

const Folders = ({ View, filter, ...props }) => {
  const WrappedView = useMemo(() => withLoader(View), []);

  const query = useQuery(FOLDERS, {
    variables: filter,
  });

  const onLoadMore = () => {
    const length = get(query, "data.folders.data", []).length;
    query
      .fetchMore({
        variables: {
          where: {
            ...filter?.where,
            range: `${length + 1}-${length + PAGINATION_SIZE}`,
          },
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) {
            return prev;
          }
          return {
            ...prev,
            folders: {
              ...prev.folders,
              data: [...prev.folders.data, ...fetchMoreResult.folders.data],
            },
          };
        },
      })
      .catch(() => {});
  };

  return (
    <WrappedView
      {...{
        ...props,
        ...query,
        filter,
        type: "folders",
        onLoadMore,
      }}
    />
  );
};

Folders.propTypes = {
  View: PropTypes.func.isRequired,
  filter: PropTypes.object,
};

Folders.defaultProps = {
  filter: {},
};

export default Folders;
